import config from "./config";
var axios = config();

export default {
  // get
  impersonate(asuriteId) {
    return axios.get("/Impersonation/" + asuriteId);
  },

  stopImpersonation() {
    return axios.get("/StopImpersonation");
  },

  // post
  logOff() {
    return axios.post("/Home/LogOff");
  }
};
